import {useSelector} from 'react-redux';

import {tariffAPI} from 'entities/tariff';
import {userSelector} from 'entities/user';

import {getFreeTariffFacts, IFreeTariffFact} from '../lib/freeTariffFacts';
import {
    getAdvantagesMinPrice,
    getIncludedAdvantages,
    getOfferedAdvantages,
    ITariffAdvantageState,
    pickTariffAdvantages,
} from '../lib/tariffAdvantages';

export interface ILandingState {
    facts: IFreeTariffFact[],
    offered: ITariffAdvantageState[],
    included: ITariffAdvantageState[],
    price: number | null,
}

export const useLanding = (): ILandingState => {
    const user = useSelector(userSelector);
    const {data} = tariffAPI.useGetTariffsQuery({field: 'price', direction: 'asc'});

    const tariffs = data ?? [];
    const advantages = pickTariffAdvantages(tariffs, user?.tariff);
    const offered = getOfferedAdvantages(advantages);

    return {
        facts: getFreeTariffFacts(tariffs),
        offered,
        included: getIncludedAdvantages(advantages),
        price: getAdvantagesMinPrice(tariffs, offered),
    };
};

export default useLanding;
